import { Model, RailsFormat } from "./model";
import { MatrixClass } from "./matrix-class";
import { Term } from "./term";
import { Course } from "./course";
import { Day } from "./day";
import { Campus } from "./campus";
import { Workshop } from "./workshop";
import * as moment from "moment";

export class Window extends Model implements RailsFormat {

  constructor(
    public id?: number,
    public workshopId?: number,
    public campusId?: number,
    public dayId?: number,
    public startTime: Date = null,
    public endTime: Date = null,
    public lunchStartTime: Date = null,
    public lunchEndTime: Date = null,
    public createdAt: Date = null,
    public updatedAt: Date = null,

    public hasLunchtime: boolean = false,
    public isEditing: boolean = false,

    public campus: Campus = null,
    public day: Day = null,
    public workshop: Workshop = null,
  ) {
    super()
  }

  static clone(obj: any) {
    const window = new this()

    if (obj.id) { window.id = obj.id }
    if (obj.workshopId) { window.workshopId = obj.workshopId }
    if (obj.campusId) { window.campusId = obj.campusId }
    if (obj.dayId) { window.dayId = obj.dayId }
    if (obj.startTime) { window.startTime = new Date(obj.startTime) }
    if (obj.endTime) { window.endTime = new Date(obj.endTime) }
    if (obj.lunchStartTime) { window.lunchStartTime = new Date(obj.lunchStartTime) }
    if (obj.lunchEndTime) { window.lunchEndTime = new Date(obj.lunchEndTime) }

    if (obj.campus) { window.campus = Campus.clone(obj.campus) }
    if (obj.day) { window.day = Day.clone(obj.day) }

    if (obj.workshop) { window.workshop = Workshop.clone(obj.workshop) }

    if (obj.lunchStartTime && obj.lunchEndTime) {
      window.hasLunchtime = true
    }
    if (obj.isEditing) { window.isEditing = obj.isEditing }

    if (obj.createdAt) { window.createdAt = new Date(obj.createdAt) }
    if (obj.updatedAt) { window.updatedAt = new Date(obj.updatedAt) }

    return window
  }

  serializeForRails(): any {
    const response: any = Object.assign({}, this) 

    if (this.id === 0) { response.id = null }

    if (!response.hasLunchtime) {
      response.lunchStartTime = null
      response.lunchEndTime = null
    }
    delete response.hasLunchtime

    return response
  }

  setStandardLunchtimes() {
    this.startTime = moment().set({ 'hour': 9, 'minute': 30, 'second': 0 }).toDate()
    this.endTime = moment().set({ 'hour': 17, 'minute': 30, 'second': 0 }).toDate()
    this.lunchStartTime = moment().set({ 'hour': 12, 'minute': 30, 'second': 0 }).toDate()
    this.lunchEndTime = moment().set({ 'hour': 13, 'minute': 30, 'second': 0 }).toDate()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/window.ts